import { call, put, takeLatest } from "redux-saga/effects"
import { callApi } from "sagas/Api"
import { GET_USER_AGREEMENTS_STATUS, storeUserAgreementsStatus } from "actions"
import { getAgreements } from "apis/Agreements"
import { handlingGetApiError } from "./CommonErrorHandling"

export function* handleGetUserAgreementsStatus() {
  yield takeLatest(GET_USER_AGREEMENTS_STATUS, execGetUserAgreementsStatus)
}

export function* execGetUserAgreementsStatus() {
  const { payload, error } = yield call(callApi, getAgreements)
  if (payload && !error) {
    yield put(storeUserAgreementsStatus(payload))
  } else {
    yield call(handlingGetApiError, error)
  }
}
